import React, { useState } from "react";
import { resolveImageUrl } from "../../utils/imageStorage.js";

export const Logo = ({
  className = "",
  size = "md",
  showText = true,
  theme = "light",
  logoUrl = "",
  siteName,
  siteNameBn
}) => {
  const [imgError, setImgError] = useState(false);
  const iconDimensions = {
    sm: "w-10 h-10",
    md: "w-14 h-14",
    lg: "w-20 h-20",
    xl: "w-32 h-32"
  }[size];
  const titleSizes = {
    sm: "text-sm font-bold",
    md: "text-base sm:text-lg font-serif font-extrabold tracking-tight",
    lg: "text-xl font-serif font-extrabold tracking-tight",
    xl: "text-3xl font-serif font-extrabold tracking-tight"
  }[size];
  const subtitleSizes = {
    sm: "text-[10px]",
    md: "text-xs tracking-widest font-semibold",
    lg: "text-sm tracking-widest font-semibold",
    xl: "text-base tracking-widest font-semibold"
  }[size];
  const resolvedLogo = logoUrl ? resolveImageUrl(logoUrl) : "";

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`relative ${iconDimensions} shrink-0 flex items-center justify-center`}>
        {resolvedLogo && !imgError ? (
          <img
            src={resolvedLogo}
            alt={siteName || "Baitul Muqaddas Logo"}
            className="w-full h-full object-contain rounded-lg drop-shadow-xs"
            referrerPolicy="no-referrer"
            onError={() => setImgError(true)}
          />
        ) : (
          <svg
            viewBox="0 0 200 220"
            className="w-full h-full drop-shadow-sm"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 100 12 C 100 12, 102 28, 104 36 C 138 42, 160 70, 160 100 L 40 100 C 40 70, 62 42, 96 36 C 98 28, 100 12, 100 12 Z"
              fill="url(#goldGradientLogo)"
            />
            <path
              d="M 100 2 L 102 14 L 98 14 Z"
              fill="#d97706"
            />
            <circle cx="100" cy="5" r="3" fill="#fbbf24" />
            <rect x="36" y="98" width="128" height="8" rx="2" fill="#ca8a04" />
            <path
              d="M 24 104 L 176 104 L 176 195 C 176 198, 173 200, 170 200 L 30 200 C 27 200, 24 198, 24 195 Z"
              fill="#064e3b"
            />
            <path
              d="M 64 200 L 64 140 C 64 116, 136 116, 136 140 L 136 200 Z"
              fill="#ffffff"
            />
            <g transform="translate(85, 126) scale(0.65)">
              <path
                d="M 23 2 C 16 0, 5 3, 0 8 L 0 38 C 5 33, 16 30, 23 32 Z"
                fill="#064e3b"
              />
              <path
                d="M 23 2 C 30 0, 41 3, 46 8 L 46 38 C 41 33, 30 30, 23 32 Z"
                fill="#064e3b"
              />
              <line x1="23" y1="2" x2="23" y2="33" stroke="#ffffff" strokeWidth="2" />
            </g>
            <path
              d="M 52 176 Q 64 186 80 182 Q 95 178 108 184 Q 124 190 148 174 Q 138 168 126 172 Q 112 176 98 172 Q 78 168 52 176 Z"
              fill="#064e3b"
            />
            <defs>
              <linearGradient id="goldGradientLogo" x1="40" y1="20" x2="160" y2="100" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#fef08a" />
                <stop offset="40%" stopColor="#f59e0b" />
                <stop offset="100%" stopColor="#b45309" />
              </linearGradient>
            </defs>
          </svg>
        )}
      </div>

      {showText && (
        <div className="flex flex-col">
          <span
            className={`font-serif tracking-wider ${titleSizes} ${theme === "dark" ? "text-white" : "text-emerald-950"}`}
          >
            {siteName || "BAITUL MUQADDAS"}
          </span>
          <span
            className={`font-sans uppercase font-semibold ${subtitleSizes} ${theme === "dark" ? "text-emerald-300" : "text-emerald-800"}`}
          >
            {siteNameBn ? "MODEL MADRASAH" : "MODEL MADRASAH"}
          </span>
        </div>
      )}
    </div>
  );
};
